import { Button } from '@radix-ui/themes'
import React from 'react'
import styled, { css } from 'styled-components'

const activeButtonStyles = css<{ $isWarning?: boolean }>`
  background-color: ${({ theme, $isWarning }) =>
    $isWarning
      ? `color-mix(in srgb, ${theme.forecast.warning} 80%, transparent 20%)`
      : theme.forecast.defaultButton};
  color: ${({ theme }) => theme.forecast.defaultText};
  font-weight: bold;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverButton};
  }

  &:active {
    background-color: ${({ theme, $isWarning }) =>
      $isWarning
        ? `color-mix(in srgb, ${theme.forecast.warning} 80%, transparent 20%)`
        : theme.forecast.defaultButton};
    color: ${({ theme }) => theme.forecast.activeText};
  }
`

const RowItemPickerContainer = styled.div<{ $height?: string }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0.25rem;
  height: ${({ $height }) => $height ?? '2.5rem'};
  gap: 0.25rem;
  background-color: ${({ theme }) => theme.forecast.cardGroupBackground};
  border-radius: 0.375rem;
  width: fit-content;
`

export const RowItem = styled(Button)<{
  $isActive: boolean
  $isWarning?: boolean
}>`
  display: flex;
  align-items: center;
  padding: 0.25rem 0.5rem;
  height: 100%;
  text-decoration: none;
  cursor: pointer;
  border-radius: 0.25rem;
  color: ${({ theme, $isWarning }) =>
    $isWarning ? theme.forecast.defaultText : theme.forecast.secondaryText};
  font-size: 0.875rem;
  line-height: 1.25rem;
  font-weight: 500;
  background-color: ${({ theme, $isWarning }) =>
    $isWarning
      ? `color-mix(in srgb, ${theme.forecast.warning}, transparent 80%)`
      : theme.forecast.defaultGhostButton};

  &:hover {
    background-color: ${({ theme }) => theme.forecast.hoverGhostButton};
  }

  ${({ $isActive }) => $isActive && activeButtonStyles}
`

interface RowItemPickerProps {
  height?: string
  className?: string
  children: React.ReactNode
}

export const RowItemPicker: React.FC<RowItemPickerProps> = ({
  height,
  children,
  className,
}) => {
  return (
    <RowItemPickerContainer $height={height} className={className}>
      {children}
    </RowItemPickerContainer>
  )
}
